import type { LandingPageTestimonial } from '@/app/components/LandingPage/LandingPageTestimonials/types';

//TODO: GROW-1607 clean up Gen3 clean up
export const businessCaseStudies: LandingPageTestimonial[] = [
  {
    action: {
      messageKey: 'business_case_study_action',
      link: 'https://ouraring.com/blog/shane-heath-mud-wtr/',
    },
    company: 'MUD/WTR',
    id: 'shane-heath',
    image: {
      alt: 'business_image_mudwtr_alt',
      src: 'blue-sky/oura-for-business/business-mudwtr.png',
    },
    name: 'Shane Heath, Founder',
    quote: 'business_case_study_quote',
    tag: 'business_case_study_title',
  },
  {
    action: {
      messageKey: 'business_case_study_action',
      link: 'https://ouraring.com/blog/all-hours-with-oura-jalen-brunson/',
    },
    company: 'New York Knicks',
    id: 'jalen-brunson',
    image: {
      alt: 'personal_insights_image_alt_3',
      src: 'blue-sky/why-oura/personal-insights-august-1.jpg',
    },
    name: 'Jalen Brunson, Knicks Guard',
    quote: 'business_human_performance_article_quote',
    tag: 'business_human_performance_article_eyebrow',
  },
];
//TODO: GROW-1607 clean up Gen3 clean up
export const businessCaseStudiesOR4: LandingPageTestimonial[] = [
  {
    action: {
      messageKey: 'business_case_study_action',
      link: 'https://ouraring.com/blog/shane-heath-mud-wtr/',
    },
    company: 'MUD/WTR',
    id: 'shane-heath',
    image: {
      alt: 'business_image_mudwtr_alt',
      src: 'blue-sky/oura-for-business/business-mudwtr.png',
    },
    name: 'Shane Heath, Founder',
    quote: 'business_case_study_quote',
    tag: 'business_case_study_title',
  },
  {
    action: {
      messageKey: 'business_case_study_action',
      link: 'https://ouraring.com/blog/all-hours-with-oura-jalen-brunson/',
    },
    company: 'New York Knicks',
    id: 'jalen-brunson',
    image: {
      alt: 'personal_insights_image_alt_3',
      src: 'business/basket-ball-oreo.jpg',
    },
    name: 'Jalen Brunson, Knicks Guard',
    quote: 'business_human_performance_article_quote',
    tag: 'business_human_performance_article_eyebrow',
  },
];
